import Image2880 from "../thumbnails/2880-WebTeam.png";
import Image1440 from "../thumbnails/1440-WebTeam.png";
import Image720 from "../thumbnails/720-WebTeam.png";
import Image360 from "../thumbnails/360-WebTeam.png";
import Image180 from "../thumbnails/180-WebTeam.png";
export default {2880: Image2880, 1440: Image1440, 720: Image720, 360: Image360, 180: Image180, }